import TableEmpyArea from 'pages/import/TableEmptyArea';
import React from 'react';
import theme from 'source/theme';
// Imported rather than linked by path so the bundler emits them with a hash of
// their contents. The href changes when the file does, which is what lets them
// be cached like everything else; `download` restores the name the person
// should see, since the emitted one carries the hash.
import fornecedoresTemplate from 'templates/fornecedores.xlsx';
import materiasPrimasTemplate from 'templates/materias-primas.xlsx';
import { TABLE_HEIGHT } from 'utils/ui/constants';

const TABLE_HEIGHT_CUSTOM = TABLE_HEIGHT(true,71);

export default () =>
  <TableEmpyArea bodyHeight={TABLE_HEIGHT_CUSTOM}>
    <div>
      <p>
        Nesta área pode importar ficheiros XLSX de dados relacionados com
        Matérias Primas e Fornecedores.
      </p>
      <p>
        Abaixo tem exemplos de ficheiros de importação:
      </p>
      <ul>
        <li>
          <a
            href={materiasPrimasTemplate}
            download="materias-primas.xlsx"
            style={{ color: theme.palette.primary.main }}
          >
            Template XLSX Matérias Primas
          </a>
        </li>
        <li>
          <a
            href={fornecedoresTemplate}
            download="fornecedores.xlsx"
            style={{ color: theme.palette.primary.main }}
          >
            Template XLSX Fornecedores
          </a>
        </li>
      </ul>
    </div>
  </TableEmpyArea>;
